<template>
    <section class="content">
            <box title="Filtro">
                <div slot="body">
                  <div class="row">
                    <div class="col-sm-5">
                      <div class="input-group">
                        <input v-show="filtro==='ID'" style="height: 34px;" type="number" class="form-control" v-model="filter" placeholder="Pesquisa por ID">
                        <input v-show="filtro==='NOME'" style="height: 34px;" type="text" class="form-control" v-model="filter_name" placeholder="Pesquisa por NOME">
                        <div class="input-group-btn">
                          <button type="button" class="btn btn-default dropdown-toggle" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">{{filtro}} <span class="caret"></span></button>
                          <ul class="dropdown-menu dropdown-menu-right">
                            <li><a href="javascript:;" @click="filtro='ID';filter=filter_name;filter_name=''">ID</a></li>
                            <li role="separator" class="divider"></li>
                            <li><a href="javascript:;" @click="filtro='NOME';filter_name=filter;filter=''">Nome</a></li>
                          </ul>
                        </div><!-- /btn-group -->
                      </div><!-- /input-group -->
                    </div><!-- /.col-lg-6 -->
                    <div class="col-sm-3">
                      <div class="form-group">
                        <select class="form-control" id="exampleFormControlSelect1" v-model="status">
                          <option :value="0">Todos Estados</option>
                          <option :value="2">Em Espera</option>
                          <option :value="3">Aprovado</option>
                          <option :value="4">Reprovado</option>
                          <option :value="5">Personalizado</option>
                        </select>
                      </div>
                    </div>
                  </div>
                  
                  <br>
                  <div class="row" style="display: flex">
                    <div class="col-md-2 btn-group" data-toggle="buttons" >
                      <label class="btn btn-primary radioOntem" @click="filtrarData('ontem')" id="radioOntem">
                        <input type="radio" autocomplete="off" > Ontem
                      </label>
                      <label class="btn btn-primary radioHoje" @click="filtrarData('hoje')" id="radioHoje">
                        <input type="radio" autocomplete="off" > Hoje
                      </label>
                    </div>
                    <div class="col-md-3">
                      <div class="input-group">
                        <span class="input-group-addon" id="sizing-addon1" style="background: #367FA9; color: white;">Data Inicial</span>
                        <input type="date" class="form-control" aria-describedby="sizing-addon1" v-model="dataInicial" @change="filtrarData" style="height: 34px;">
                      </div>
                    </div>
                    <div class="col-md-3">
                      <div class="input-group" >
                        <span class="input-group-addon" id="sizing-addon2" style="background: #367FA9; color: white;">Data Final</span>
                        <input type="date" class="form-control"  aria-describedby="sizing-addon2" v-model="dataFinal" @change="filtrarData" style="height: 34px;">
                      </div>
                    </div>
                  </div>
                </div>
            </box>

            <box>
            <div slot="body">
                <div class="dataTables_wrapper form-inline dt-bootstrap" id="example1_wrapper">
                <div class="row">
                    <div class="col-sm-6">
                    <div id="example1_length" class="dataTables_length">

                    </div>
                    </div>
                </div>

                <div class="row">
                    <div class="col-sm-12 table-responsive">
                    <table aria-describedby="example1_info" role="grid" id="example1" class="table table-borde#F48668 table-striped dataTable">
                        <thead>
                        <tr>
                            <th v-for="coluna in colunas">
                                <a href="javascript:;" @click="orderPedidos(coluna.json)" >
                                  <div class="row">
                                    <div class="col-sm-7">
                                      {{coluna.name | ucwords}}
                                    </div>
                                    <div class="col-sm-2">
                                      <i v-if="order.keys===coluna.json && order.sort==='asc'" class="fa fa-sort-asc" aria-hidden="true"></i>
                                      <i v-else-if="order.keys===coluna.json && order.sort==='desc'" class="fa fa-sort-desc" aria-hidden="true"></i>
                                      <i v-else-if="coluna.json!=='observacao'" class="fa fa-sort" aria-hidden="true"></i>
                                    </div>
                                  </div>
                                 </a>
                            </th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-if="solicitacoesFiltered.length === 0">
                          <td colspan="12">Nenhum Pedido Localizado</td>
                        </tr>
                        <tr v-else class="even" role="row" v-for="(p, index) in solicitacoesFiltered">
                            <td>
                              <router-link class="padding" :to="{ name: 'Detalhe Solicitação', params: { id: p.id} }" >
                                {{p.id}}
                              </router-link>
                            </td>
                            <td>{{p.Clientes.nome | upperCase}}</td>
                            <td id="obs">{{p.Pacotes ? p.Pacotes.titulo : 'Pacote Personalizado' }}</td>
                            <td>R$ {{p.Pacotes ? p.Pacotes.preco.toFixed(2) : 0}}</td>
                            <td>{{p.datahora | data}}</td>
                            <td v-if="p.statusid == 2 " class="coluna">
                            <select class="form-control" v-model="p.statusid" style="background: #FFF95B;border-color: #FFF95B;padding: 0px" @change="gravarEstado(p.id,p.statusid)">
                                <option v-for="e in estados" v-bind:value="e.id">{{e.descricao}}</option>
                            </select>
                            </td>
                            <td v-if="p.statusid == 3"  class="coluna">
                            <select  class="form-control" v-model="p.statusid" style="background: #88D89D;border-color: #88D89D;padding: 0px" @change="gravarEstado(p.id,p.statusid)">
                                <option v-for="e in estados" v-bind:value="e.id">{{e.descricao}}</option>
                            </select>
                            </td>
                            <td v-if="p.statusid == 4" class="coluna">
                            <select  class="form-control" v-model="p.statusid" style="background: #F48668;border-color: #F48668;padding: 0px" @change="gravarEstado(p.id,p.statusid)">
                                <option v-for="e in estados" v-bind:value="e.id">{{e.descricao}}</option>
                            </select>
                            </td>
                            <td v-if="p.statusid == 5" style="" class="coluna">
                            <select  disabled class="form-control" style="padding: 0px" >
                                <option >Personalizado</option>
                            </select>
                            </td>
                        </tr>
                        <tr>
                          <td colspan="3" style="text-align: center">
                            <label>Total</label>
                          </td>
                          <td>
                            <label>R$ {{totalPedidos}}</label>
                          </td>
                        </tr>               
                        </tbody>
                        <tfoot>
                        </tfoot>
                    </table>
                    </div>
                </div>
                </div>

                <!-- /.box-body -->
            </div>
        </box>
    </section>
</template>

<script>
import axios from 'axios'
import _ from 'lodash'
import Box from '../Box'
import resource from './resource'

export default {
  name: 'Pedidos',
  components: {
    'box': Box,
  },
  data () {
    return {
      imprimir: false,
      order: {
        keys: 'estado.id',
        sort: 'asc'
      },
      filter: '',
      filter_name: '',
      pagamento: [],
      endereco: null,
      filtro: 'ID',
      colunas_pagamento: ['Formas Pagamento',''],
      colunas: [
        {
          name : 'id',
          json: 'id'
        },
        {
          name : 'Cliente',
          json: 'Clientes.nome'
        },
        {
            name: 'Pacote',
            json: 'Pacotes.titulo'
        },
        {
          name : 'total',
          json: 'Pacotes.preco'
        },
        {
          name : 'data hora',
          json: 'datahora'
        },
        {
          name : 'estado',
          json: 'statusid'
        }
      ],
      solicitacoes: [],
      estados: [],
      solicitacoes_id: 0,
      nome_cliente: '',
      contato: '',
      itens_pedido: [],
      config: [],
      total_pedido: 0,
      dataInicial: '',
      dataFinal: '',
      hoje: false,
      ontem: false,
      solicitacoesFiltradas: [],
      status: 0,
      desconto: 0
    }
  },
  created () {
    this.getSolicitacoes()
    this.getEstados()
  },
  methods: {
    filtrarData(dia) {

      var hoje = new Date();

      var ontem = new Date(hoje.getTime());
      ontem.setDate(hoje.getDate() - 1);

      console.log(dia)
      if(dia === 'ontem') {
        if(this.ontem) {
          this.ontem = false
          this.dataInicial = ''
          this.dataFinal = ''
          console.log('remove calsse')
          setTimeout(() => {
            var element = document.getElementById("radioOntem");
            element.classList.remove("active");
          }, 100)
          return
        } 
        this.ontem = true;
        this.hoje = false;
        this.dataFinal = this.getData(ontem);
        this.dataInicial = this.dataFinal;
      } else if (dia === 'hoje'){
        if(this.hoje) {
          this.hoje = false
          this.dataInicial = ''
          this.dataFinal = ''
          console.log('remove calsse')
          setTimeout(() => {
            var element = document.getElementById("radioHoje");
            element.classList.remove("active");
          }, 100)
          return
        } 
        this.ontem = false;
        this.hoje = true;
        this.dataFinal = this.getData(hoje);
        this.dataInicial = this.dataFinal;
      } else {
        console.log(this.dataFinal)
        this.ontem = false;
        this.hoje = false;
        setTimeout(() => {
          var element = document.getElementById("radioOntem");
          var element2 = document.getElementById("radioHoje");
          element.classList.remove("active");
          element2.classList.remove("active");
        }, 100)
      }
    },
    getData(data) {
      let year = data.getFullYear().toString();
      let month = (data.getMonth()+1).toString();
      let day = data.getDate().toString();
      return `${year}-${month.length < 2 ? '0'+month : month}-${day}`
    },
    getSolicitacoes () {
      resource.getListaSolicitacoes().then(response => {
        this.solicitacoes = response.data
        for(var solicitacao in this.solicitacoes) {
          this.solicitacoes[solicitacao].Clientes.nome = this.solicitacoes[solicitacao].Clientes.nome + ' '+ this.solicitacoes[solicitacao].Clientes.sobrenome
        }
        console.log('get solicitacao -> ', this.solicitacoes)
      })
    },
    getEstados() {
      resource.getEstados().then(res => {
        this.estados = res.data.filter(element => {
          return element.id != 1 && element.id != 5
        })
      }).catch(err => {
        alert(err)
      })
    },
    orderPedidos (coluna) {
      if(coluna !== 'observacao') {
        this.order.keys = coluna
        this.order.sort = this.order.sort === 'desc' ? 'asc' : 'desc'
      }
    },
    detalheSolicitacao(id) {
      this.$router.go(`/solicitacoes/${id}`)
    },
    gravarEstado (id, estado) {
      console.log('estado => ', estado)
      resource.atualizaEstado(id, { estado }).then(response => {
          if (response.data.success) {
            this.getSolicitacoes() // busca novamente os pedidos
            if(estado !== 1 && this.config.notifica_cliente) {
              var textarea
              // if(estado===2) textarea = this.config.texto_padrao_aprovado
              // else if(estado===3) textarea = this.config.texto_padrao_reprovado
              // else if(estado===5) textarea = this.config.texto_padrao_cancelado
              // else if(estado===6) textarea = this.config.texto_padrao_entrega

              // textarea = textarea.split('#NOME').join(nome)
              // textarea = textarea.split('#SOBRENOME').join(sobrenome)
              // textarea = textarea.split('#IDPEDIDO').join(id)
              // textarea = textarea.split('#FACEID').join(fb_id)
              // textarea = textarea.split('#PRECOTOTAL').join(preco_total)
              // textarea = textarea.split('#TEMPOENTREGA').join(this.config.tempo_entrega)
              this.$swal({
                title: 'Mensagem de Notificação',
                html: '<textarea class="form-control textarea" rows="3" id="txtArea" >'+textarea+'</textarea>',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Enviar'
              }).then((result) => {
                if (result.value) {
                  textarea = document.getElementById('txtArea').value
                  this.notifca_cliente(textarea,estado,fb_id)
                  
                }
              })
            }
            
          } else {
            this.$swal(
          'Ops!',
          'Não foi possivel alterar o status. Nenhuma alteração foi realizada.',
          'error'
        )
          }
        })
    },
    notifca_cliente (msg, estado, fb_id) {
      let url= this.$store.state.api_bot+'pedidos/estado_pedido?fb_id='+fb_id+'&estado='+estado+'&msg='+msg

      axios.get(url).then(response => {
        this.$swal({
            position: 'top-end',
            type: 'success',
            title: 'Cliente Notificado',
            showConfirmButton: false,
            timer: 1500
          })   
      })
    }
  },
  
  filters: {
    ucwords (value) {
      return value.charAt(0).toUpperCase() + value.slice(1)
    },
    upperCase(value) {
      return value.toUpperCase()
    },
    data (value) {
      var data = new Date(value)
      var dia = data.getDate()
      var mes = data.getMonth() + 1
      var ano = data.getFullYear()
      var hr = data.getHours()
      var min = data.getMinutes()
      return dia + '/' + mes + '/' + ano + ' - ' + hr + ':' + min
    }
  },
  computed: {
    solicitacoesFiltered () {
      console.log('estado pedido ==> ', this.status)
      var solicitacoesAjustadas = this.solicitacoes
      this.filter_name = this.filter_name.toLowerCase()
      let colecao = _.orderBy(solicitacoesAjustadas, this.order.keys, this.order.sort)

      if(this.dataInicial && this.dataFinal) {
        
        this.solicitacoesFiltradas =  _.filter(colecao, item => {
          console.log('itens ==> ', item)
          return item.id.indexOf(this.filter) >= 0 && item.Clientes.nome.indexOf(this.filter_name) >= 0 && item.datahora.split('T')[0] <= this.dataFinal && item.datahora.split('T')[0] >= this.dataInicial && (this.status !== 0 ? item.statusid === this.status : true)
        })
        return this.solicitacoesFiltradas;
      }

      this.solicitacoesFiltradas = _.filter(colecao, item => {
        return item.id.indexOf(this.filter) >= 0 && item.Clientes.nome.toLowerCase().indexOf(this.filter_name) >= 0 && (this.status !== 0 ? item.statusid === this.status : true)
      })
        console.log('solicitacoesFiltradas ==> ', this.solicitacoesFiltradas)
      return this.solicitacoesFiltradas;
    },
    totalPedidos() {
      let total = 0;
      this.solicitacoesFiltradas.forEach(solicitacao => {
        total += solicitacao.Pacotes ? solicitacao.Pacotes.preco : 0;
      });
      return total.toFixed(2)
    }
  }
}
</script>
<style>

.coluna {
    width:190px;
}
.url_imagem {
    width: 80px;
}
td, th {
      font-size: 15px;
  }

.endereco-title{
  text-align: center
}
.endereco-body{
  text-align: center;
  /* margin-top: 3% */
}
.End {
  font-size: 15px
}
.adicionais {
  font-size: 12px;
  font-style: italic;
  margin: 0
}
</style>



// WEBPACK FOOTER //
// Solicitacoes.vue?84efbd38